// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3vhLn","options":"AnswerScale_options__3G-iJ","selected":"AnswerScale_selected__1zyi8"};